export default __webpack_public_path__ + "static/media/awm.ba06cb16.svg";